export enum DevicePlatform {
    Unknown,
    Web_Desktop,
    Web_Tablet,
    Web_Phone,
    App_Iphone,
    App_Ipad,
    App_Android_Phone,
    App_Android_Tablet,
}

export const getDevicePlatform = (): DevicePlatform => {
    const { userAgent } = navigator;

    // Detect iOS devices
    if (/iPhone|iPod/i.test(userAgent)) {
        return DevicePlatform.App_Iphone;
    }
    if (
        /iPad/i.test(userAgent) ||
        (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform))
    ) {
        // iPads can sometimes be detected as Mac devices, so we check for touch points
        return DevicePlatform.App_Ipad;
    }

    // Detect Android devices
    if (/Android/i.test(userAgent)) {
        return window.matchMedia("(min-width: 720px)").matches
            ? DevicePlatform.App_Android_Tablet
            : DevicePlatform.App_Android_Phone;
    }

    // Detect Web devices based on screen size
    if (window.matchMedia("(max-width: 768px)").matches) {
        return DevicePlatform.Web_Phone;
    }
    if (window.matchMedia("(min-width: 769px) and (max-width: 1024px)").matches) {
        return DevicePlatform.Web_Tablet;
    }

    // Default to Web Desktop for larger screens
    if (window.matchMedia("(min-width: 1025px)").matches) {
        return DevicePlatform.Web_Desktop;
    }

    // Fallback to Unknown
    return DevicePlatform.Unknown;
};
